/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M19 8h-14", "key": "svg-0" }], ["path", { "d": "M5 12h7", "key": "svg-1" }], ["path", { "d": "M12 16h-7", "key": "svg-2" }], ["path", { "d": "M16 14l4 4", "key": "svg-3" }], ["path", { "d": "M20 14l-4 4", "key": "svg-4" }]];
const IconPlaylistX = createReactComponent("outline", "playlist-x", "PlaylistX", __iconNode);

export { __iconNode, IconPlaylistX as default };
//# sourceMappingURL=IconPlaylistX.mjs.map
